import { marqueeItems } from "../data/content";
import "./Marquee.css";

/**
 * Faixa de tecnologias em rolagem contínua.
 * A lista é duplicada para o loop não ter costura visível.
 */
export function Marquee() {
  return (
    <div className="marquee" aria-label="Tecnologias com que trabalho">
      <div className="marquee__track">
        {[0, 1].map((copy) => (
          <ul className="marquee__group" key={copy} aria-hidden={copy === 1}>
            {marqueeItems.map((item) => (
              <li key={`${copy}-${item}`} className="marquee__item">
                {item}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
